// Решение гейта Ren для маршрута /ai-assistant (meta.requiresRen) — отдельным
// модулем по образцу staffGate.js, чтобы проверять его поведенчески, не
// импортируя @/router (причины — в шапке staffGate.js).
import { REN_ROLES } from "@/constants/roles";

// Возвращает аргумент для next() — либо undefined, если роль пропускаем.
//
// Allowlist, а не «не partner и не agent»: тот же урок, что у staffGate
// (инцидент 12.08.2026 — отрицание молча пропустило роль, заведённую позже).
//
// Пустая роль — не отказ, и по той же причине, что в staffGate: гидрация
// vuex-persist синхронна, но сохранённого блока может не оказаться при живом
// auth_token, а выбросить сотрудника на Home из-за этого хуже, чем пустить
// дальше. Гейт здесь — UX; настоящая защита — 403 бэкенда для partner и
// agent на каждом запросе чата.
export function renGateRedirect(role) {
  if (role && !REN_ROLES.includes(role)) {
    return { name: "Home", query: { error: "ren_unavailable" } };
  }
  return undefined;
}
